import styled, { css } from 'styled-components'
import { Spacing, Typography, Colors } from 'cio-design-library/design-tokens'
import Tabs, { Tab } from 'builder/components/Tabs'
import { TabSelector } from 'builder/components/Tabs/styles'

export const Container = styled.div`
  position: sticky;
  top: 0;
  background-color: ${Colors.White};
  z-index: 1;
`

export const TabsContainer = styled(Tabs)`
  justify-content: center;
  padding: 0 ${Spacing.L};

  ${TabSelector} {
    height: 3px;
  }
`

export const TabControls = styled(Tab)`
  align-items: center;
  text-align: center;
  margin-right: 0;
  padding: 16px 0;
  flex: 1;

  ${props =>
    props.isActive &&
    css`
      font-weight: ${Typography.weights.medium};
    `}
`
